import styled from '@emotion/styled';
import * as React from 'react';
import { colors } from '~/styles/constants';

const FlexWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;

const StyledListItem = styled('li')`
  margin: 0;
  padding: 8px 24px;
  cursor: pointer;
  transition: background-color 100ms;
  font-size: 14px;
  line-height: 1.8;
  color: ${colors.fontColor};
  display: flex;
  align-items: center;

  :hover {
    background-color: ${colors.almostWhite};
  }
`;

interface BoxIconFigureProps {
  isCarrier?: boolean;
}

// eslint-disable-next-line @typescript-eslint/ban-types
const BoxIconFigure = styled('figure')<BoxIconFigureProps>`
  margin: 0 24px 0 0;
  display: flex;
  align-items: center;

  img {
    width: ${(props) => (props.isCarrier ? '45px' : '25px')};
  }
`;

const ListItemSubtitle = styled('div')`
  font-weight: 300;
  line-height: 1;
`;

interface ListItemProps {
  icon?: string;
  subtitle?: string;
  onClick?: React.MouseEventHandler<HTMLLIElement>;
  isCarrier?: boolean;
  dataAnalytics?: string;
  dataPendo?: string;
  children: React.ReactNode;
}

const ListItem = (props: ListItemProps) => {
  const figure = props.icon ? (
    <BoxIconFigure isCarrier={props.isCarrier}>
      <img src={props.icon} alt="" />
    </BoxIconFigure>
  ) : null;

  return (
    <StyledListItem
      onClick={props.onClick}
      data-pendo={props.dataPendo}
      data-analytics={props.dataAnalytics}
    >
      {figure}
      <FlexWrapper>
        <div>{props.children}</div>
        <ListItemSubtitle>{props.subtitle}</ListItemSubtitle>
      </FlexWrapper>
    </StyledListItem>
  );
};

export default ListItem;
